import Vue from 'vue'
import Router from 'vue-router'

import HomeRedirect from './views/HomeRedirect.vue'
import Receipt from './views/Receipt.vue'

// import Home from './views/Home.vue'
// import PrincipalOutlet from './views/PrincipalOutlet.vue'
// import About from './views/About.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   component: About
    // },
    // {
    //   path: '/settings',
    //   name: 'settings',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue')
    // },
    // {
    //   path: '/outlet/:outletId',
    //   name: 'outlet',
    //   component: PrincipalOutlet
    // },
    {
      path: '/',
      name: 'home',
      component: HomeRedirect
    },
    {
      path: '/r/:receiptToken',
      name: 'r',
      component: Receipt
    }
  ]
})

// NOTE: This is used to track whether the user has accessed the current
// page from url or from another page/route.
router.beforeEach((to, from, next) => {
  if (!window.__lipi_shop__) window.__lipi_shop__ = {};
  window.__lipi_shop__.lastFrom = from.path
  next()
})

export default router;